import React, { useCallback, useEffect, useState } from 'react'
import { createMessage } from '../../utilities/utilities';
import { handleError } from '../../utilities/errorHandler';
import { addClient, allClients } from '../../services/clients';
import { Container } from 'react-bootstrap';
import CustomLoader from '../shared/CustomLoader';
import ClientsTable from '../tables/ClientsTable';
import PageTitle from '../shared/PageTitle';
import Message from '../shared/Message';
import ClientForm from '../forms/ClientForm';

const Clients = () => {
    const [ isSaving, setIsSaving ] = useState(false);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ message, setMessage ] = useState({
        text: '',
        variant: '',
        show: false
    });

    const [ clients, setClients ] = useState([]);

    const handleCloseMessage = () => {
        setMessage((prevMessage) => ({...prevMessage, show: false}));
    }

    const handleMessage = (text, variant) => {
        setMessage(createMessage(text, variant));
    }

    const getClients = useCallback( async () => {
        setIsLoading(true);
        try {
            const response = await allClients();
            if (response.status === 200){           
                setClients(response.data);
            }
        } catch (error) {
            const errorMessage = handleError(error);
            if (errorMessage) {
                handleMessage(errorMessage.text, 'danger');
            }
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        getClients();
    }, [getClients]);

    const saveClient = async (data) => {
        setIsSaving(true);

        try {
            const clientData = {
                name: data.name,
                email: data.email,
                username: data.username,
                contact_person: data.contact_person,
                phone: data.phone,
                address1: data.address1,
                address2: data.address2,
                city_id: data.city.value
            };

            await addClient(clientData);
            handleMessage('Client successfully saved', 'success');
            getClients();

            return true;
        } catch (error) {
            try {
                const errorMessage = handleError(error);
                if (errorMessage) {
                    handleMessage(errorMessage.text, 'danger');
                }
            } catch (e) {
                throw e; // error to be handled by onSubmit in ClientForm.jsx
            }

            return false;
        } finally {
            await new Promise((resolve) => setTimeout(resolve, 500));
            setIsSaving(false);
        }
    }
  return (
    <Container fluid>

        <PageTitle title='Client Details' />

        <Message
            show={message.show}
            variant={message.variant}
            message={message.text}
            handleClose={handleCloseMessage}
        />

        <ClientForm
            isSaving={isSaving}
            formAction={saveClient}
        />

        {
            isLoading ? (
                <CustomLoader />
            ) : (
                <ClientsTable
                    clients={clients}
                />
            )
        }
    </Container>
  )
}

export default Clients
